import { SORT_BY } from '~/hooks/useFilter';

export const sortOptions = [
  SORT_BY.NAME_ASC,
  SORT_BY.NAME_DESC,
  SORT_BY.RECENT,
  SORT_BY.DEFAULT,
];
